import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ConsultationService, AppService, DialogService } from '../../../../../services'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { ConfirmComponent } from '../confirm-dialog/confirm.component'

const KEY = 'consultation-dialog'

@Component({
	selector: 'atyl-consultation-dialog',
	templateUrl: './consultation-dialog.component.html',
	styleUrls: ['./consultation-dialog.component.scss']
})
@Stringable({
	path: 'views/partials/layout/dialogs/consultation-dialog',
	key: KEY,
})
export class ConsultationDialogComponent extends BaseDialogComponent implements OnInit {

	@StringableValues(KEY)
  	strings: any;
	
	options:any = [];
	selectedEtat:any;

	constructor(
		public dialogRef: MatDialogRef<ConsultationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private appService: AppService,
		changeDetectorRef: ChangeDetectorRef,
		dialogService: DialogService,
		private consultationService: ConsultationService,
		public dialog: MatDialog
	 
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		this.dialogRef.updateSize("430px","210px") 
	}

	displayAutoSelectListInstru(key?: any): string | undefined {
		let selected
		if (this.data.etats) {
			this.data.etats.forEach((select) => {
				if (key && select.ID === key.ID)
					selected = select
			})
		}
		return selected ? selected.libelle : undefined
	}

	UpdateConsult(){
		let toConfirm = true;
		let nbConsult:any = this.data.donnees.consultationid.length;
		let selectedEtat = this.selectedEtat.libelle;
		
		if(toConfirm == true){
			const confDialogRef = this.dialog.open(ConfirmComponent, {
				data : {
					libelle : "Etes-vous sûr de vouloir modifier "+nbConsult+" consultation(s) et de les affecter à l'état "+ selectedEtat
				}
			});
			confDialogRef.afterClosed().subscribe(res => {
				if(res === "true"){ 
					let dataReturn = {
						etat:this.selectedEtat
					}
					this.dialogRef.close(dataReturn);
				} else {
					console.log("Aucun etat selectionné")
				}		
			})
		}
	}

}
